export var AgentStateType;
(function (AgentStateType) {
    AgentStateType["Available"] = "Available";
    AgentStateType["Unavailable"] = "Unavailable";
    AgentStateType["Offline"] = "Offline";
})(AgentStateType || (AgentStateType = {}));
//# sourceMappingURL=agent-states.js.map